import qs from "qs";
import { NODE_ENV } from "utils/env";
import { PRODUCTION, STAGING } from "utils/env/env";

export default function createLink(subdomain: string, query: string) {
  const pathname = `/bots/teams/link?${query}`;
  if (subdomain === "app") {
    const query = qs.stringify({ redirectTo: pathname });
    return `${getDomain(subdomain)}/welcome/login?${query}`;
  }

  return `${getDomain(subdomain)}${pathname}`;
}

export function getDomain(subdomain: string = "app") {
  switch (NODE_ENV) {
    case PRODUCTION:
      return `https://${subdomain}.perkbox.com`;
    case STAGING:
      return `https://${subdomain}.perkbox.net`;
    default:
      return `http://${subdomain}.localhost:3002`;
  }
}
